import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddServiceGallery from "../components/AddServiceGallery";

const AddGalleryPage = (service_id) => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Service Gallery Add' />

        {/* AddBlogLayer */}
        <AddServiceGallery serviceid={service_id}/>
      </MasterLayout>
    </>
  );
};

export default AddGalleryPage;
